
import data from '../assets/data/about.json'
export const state = () => ({ data })
